import { inject, Injectable, signal } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';
import { VolunteerProspect } from '@interfaces';
import { FuncService } from '../../../services';


/**
 * The list of tabs on this page
 */
export enum VolunteeringProspectsPageTabId {
	Prospects = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringProspectsPageViewId {
	PotentialVolunteers = 1,
	RecentlyClosed = 2,
	AllClosed = 3
}


@Injectable({ providedIn: 'root' })
export class VolunteeringProspectsService extends PageTabsLayoutPageService<VolunteeringProspectsPageTabId, VolunteeringProspectsPageViewId> {

	private func = inject(FuncService);
	public allClosedVolunteers = signal<VolunteerProspect[]>([]);

	private static readonly _viewDroplistItems1: DroplistItem<never, VolunteeringProspectsPageViewId>[] = [
		{
			uniqueId: VolunteeringProspectsPageViewId.PotentialVolunteers,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Potential Volunteers',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringProspectsPageViewId.RecentlyClosed,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Recently Closed',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringProspectsPageViewId.AllClosed,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'All Closed',
				hideText: 'never',
			},
		},
	];


	constructor() {
		super(VolunteeringProspectsService._viewDroplistItems1, VolunteeringProspectsService.name, VolunteeringProspectsPageTabId.Prospects, VolunteeringProspectsPageViewId.PotentialVolunteers);
	}

	public get viewId() {
		return VolunteeringProspectsPageViewId;
	}

	async getAllClosedVolunteers() {
		this.allClosedVolunteers.set(await this.func.volunteering.getAllClosedVolunteerProspects());
	}
}